import React from 'react'
import PlaceholderImage from 'components/PlaceholderImage'

import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

import './ChecklistPanel.scss'

/**
 * @param {String} imageType SQUARE / HORIZONTAL / VERTICAL.
 */
export const ChecklistPanel = ({
  id = `0`,
  title = null,
  detail = null,
  imageUrl = null,
  items = [],
  imageType = 'SQUARE',
  onClick = () => {},
}) => {
  const availableDimensions = {
    SQUARE: { width: '160', height: '160' },
    VERTICAL: { width: '200', height: '270' },
    HORIZONTAL: { width: '300', height: '160' },
  }

  let placeholderDimensions = null
  if (imageType) {
    placeholderDimensions = availableDimensions[imageType]
  }

  return (
    <div className={`grocery-list-panel`}>
      <div className={`columns`}>
        <div className={`col content`}>
          {title && (
            <h3 className="title" dangerouslySetInnerHTML={{ __html: title }} />
          )}
          {detail && (
            <div
              className="detail"
              dangerouslySetInnerHTML={{ __html: detail }}
            />
          )}

          {items && (
            <div className={`items`}>
              {items.map((item, i) => {
                return (
                  <div key={i}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          style={{
                            padding: '4px 8px 4px 4px',
                          }}
                          onChange={e =>
                            onClick(e.target.checked, item.id, item.label)
                          }
                          name="checkedB"
                          color="primary"
                        />
                      }
                      label={
                        <span
                          dangerouslySetInnerHTML={{ __html: item.label }}
                        />
                      }
                    />
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {imageUrl && placeholderDimensions && (
          <div className={`col image image-${imageType}`}>
            <PlaceholderImage
              src={imageUrl}
              height={placeholderDimensions.height}
              width={placeholderDimensions.width}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ChecklistPanel
